function ChangeSearchParamsRdc() {
    const changeSearchParamsRdc = (state, payload) => {
        return Object.assign(Object.assign({}, state), { isLoading: true, page: 0, searchParams: payload });
    };
    return changeSearchParamsRdc;
}
export default ChangeSearchParamsRdc;
//# sourceMappingURL=ChangeSearchParamsRdc.js.map